import { useDateStore } from '@/components/DateInput'
import { ControllerVehicleAllocation } from './ControllerVehicleAllocation'
import { isToday } from 'date-fns'
import { VehicleAllocation } from '@/pages/VehicleAllocation'
import { useNightShiftInfo } from '@/modules/Auth'

export const ControllerVehicleAllocationPage = () => {
    const { date } = useDateStore()
    const { isNightShift, isAfterMidnight } = useNightShiftInfo()

    if (isToday(date) || (isNightShift && isAfterMidnight())) {
        return <ControllerVehicleAllocation />
    }

    return <VehicleAllocation />
}
